<template>  
    <div class="widget widget-frequency">
        <div class="widget-frequency__inner">
            <h3 class="widget-frequency__heading">
                {{ $t('widgetFrequency_Heading') }}
            </h3>
            <div class="widget-frequency__gauge">
                <Gauge :value="value" 
                    :unit="$t('widgetFrequency_Unit')" 
                    :shouldTremble="true" 
                    @change="changeLevel" 
                />
            </div>
            <div class="widget-frequency__error" v-if="hasFetchError">
                {{ $t('widgetFrequency_FetchError') }}
            </div>
            <div class="widget-frequency__level-text">
                {{ levelTextKey ? $t(levelTextKey) : '' }}
            </div>
            <p class="widget-frequency__level-description">
                {{ $t('widgetFrequency_Description') }}
            </p>
            <div class="widget-frequency__link widget-frequency__link--center">
                <a :href="widgetUrl">{{ $t('widgetFrequency_Link') }}</a>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { computed, onMounted, onUnmounted, ref } from 'vue';
    import Gauge from './Gauge.vue';
    import { LEVELS } from '../constants/Gauge.constants.js';
    import { fetchFrequency } from '../service';

    const FETCH_INTERVAL = 1000 * 60; // Default fetch interval
    const MIN_FETCH_INTERVAL = 1000 * 10; // 10 seconds

    const props = defineProps({
        widgetUrl: {
            type: String,
            default: '',
        },
        fetchInterval: {
            type: [Number, String],
            default: null,
        },
    });

    const interval = ref(null);
    const value = ref(null);
    const hasFetchError = ref(false);
    const level = ref(null);

    const levelTextKey = computed(() => {
        switch(level.value) {
            case LEVELS.GREEN:
                return 'widgetFrequency_GreenText';
            case LEVELS.YELLOW:
                return 'widgetFrequency_YellowText';
            case LEVELS.RED:
                return 'widgetFrequency_RedText';
            default:
                return '';
        }
    });

    /**
     * Fetch data
     */
    async function fetchData() {
        try {
            hasFetchError.value = false;

            value.value = await fetchFrequency();
        } catch(error) {
            hasFetchError.value = true;
            value.value = null;

            console.error(error);
        }
    }

    /**
     * Change level
     */
    function changeLevel(nextLevel) {
        level.value = nextLevel;
    }

    onMounted(() => {
        fetchData();

        const fetchInterval = props.fetchInterval || FETCH_INTERVAL;

        if(fetchInterval < MIN_FETCH_INTERVAL) {
            console.error('Fetch interval is too low:', fetchInterval);

            fetchData();
            return;
        }

        interval.value = setInterval(fetchData, fetchInterval);
    });

    onUnmounted(() => {
        clearInterval(interval.value);
    });
</script>
